import { render, staticRenderFns } from "./DueDateConfig.vue?vue&type=template&id=dd9a28c0"
import script from "./DueDateConfig.vue?vue&type=script&lang=js"
export * from "./DueDateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports